export default "/_next/static/chunks/fonts/Raleway ExtraBold-84082b3f60326b4325a16549851c4860.ttf";